<template>
  <div class="page-container user_remark">
    <div class="remark_item" v-for="(item ,index) in qs_arr" :key="index" >
      <div class="common-item" v-if="(item.isCommon)">
        <el-input @blur="submitResult" autosize type="textarea" clearable placeholder="请输入内容" v-model="item.fillText"></el-input>
      </div>
      <div class="remark_item-b" v-else>
        <div class="remark_item-b-l">
          <span class="check_box" :class="{'checked':item.checked}" @click="toggle(item)"></span>
          <span class="remark_label" @click="toggle(item)">{{item.label}}</span>
        </div>
        <div class="item_text" v-if="item.type=='check_fill' && item.checked">
          <div class="remark_fill">
            <el-input @blur="submitResult" type="textarea" autosize clearable placeholder="请输入内容" v-model="item.fillText" @input="inpChange($event)"></el-input>
          </div>
        </div>
        <div class="item_text" v-if="item.type=='textArea' && item.checked">
          <el-input
            type="textarea"
            clearable
            placeholder="请输入内容"
            v-model="item.fillText"
            style="height: 30px"
          ></el-input>
        </div>
      </div>
      <!--<span @click="submitResult">保存</span>-->
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
    import {
        RestCallCenterPersonTagsControllerGetTags,
        RestCallCenterPersonTagsControllerEditPatientTags,
        RestCallCenterPersonTagsControllerGetPatientTags
    } from "@src/assets/js/api.js";

    export default {
        name: 'UserRemark',
        data() {
            return {
                qs_arr: [],
                tagInd: {}
            }
        },
        props: ["taskId", "patientData"],
        computed: {},
        components: {},
        mounted() {
            // this.onLoad()
        },
        methods: {
            onLoad() {
                let vm = this;
                vm.getTableList();
            },
            toggle(item) {
                item.checked = !item.checked;
                this.submitResult()
                this.$nextTick(() => {
                    this.$forceUpdate();
                })
            },
            inpChange (e) {
                this.$forceUpdate()
            },
            getTableList(){
                let vm = this;
                vm.getTableListAsync().then(res => {
                    if (res.status == 0) {
                        vm.qs_arr = [];
                        if (res.retValue.length>0) {
                            res.retValue.forEach((item) => {
                                let obj = {
                                    id: item.id,
                                    label: item.tag,
                                    checked: false,
                                    type: item.edit ? "check_fill" : "check",
                                    fillText: ""
                                }
                                vm.qs_arr.push(obj)
                                vm.tagInd[item.tag] = vm.qs_arr.length - 1
                            })
                        }
                    }
                    vm.getPatientTage();
                })
            },
            getPatientTage() {
                let vm = this;
                vm.getPatientTageAsync().then(res => {
                    if(res.retValue.length>0){
                        let patientTageArr = JSON.parse(res.retValue);
                        patientTageArr.forEach((item) => {
                            if(item.tag!=''&&item.tag!=undefined && item.type == 'check_fill'){
                                let qs_arr_copy = JSON.parse(JSON.stringify(vm.qs_arr))
                                for(var r=0;r<qs_arr_copy.length;r++){
                                    if(qs_arr_copy[r].label == item.tag){
                                        let result = {
                                            id: vm.qs_arr[r].id,
                                            label: item.tag,
                                            isCommon: item.tag ? false : true,
                                            checked: true,
                                            type: item.type,
                                            fillText: item.fillText,
                                        }
                                        console.log("管理台进行了配置,有输入型",result)
                                        vm.qs_arr[r]=result;
                                    }
                                }
                            }
                            if(item.type =='check' && vm.qs_arr[vm.qs_arr.length-1].id !== "0" ){
                                vm.qs_arr.forEach((item_qs,index) => {
                                    if(item_qs.label == item.tag){
                                        vm.qs_arr.splice(index,1);
                                        let obj = {
                                            id: item_qs.id,
                                            label: item.tag,
                                            isCommon: item.tag ? false : true,
                                            checked: item.tag ? true : null,
                                            type: "check",
                                            fillText: item.fillText,
                                        }
                                        vm.qs_arr.push(obj);
                                    }
                                })
                            }else if(item.fillText !='' && vm.qs_arr.length == 0){
                                // 呼叫台进行了配置
                                let obj = {
                                    id: '0',
                                    label: item.tag,
                                    isCommon: item.tag ? false : true,
                                    checked: item.tag ? true : null,
                                    type: "check_fill",
                                    fillText: item.fillText,
                                }
                                vm.qs_arr.push(obj);
                            }
                            if( item.fillText =='' && vm.qs_arr.length== 0){
                                let obj = {
                                    id: '0',
                                    label: item.tag,
                                    isCommon: item.tag ? false : true,
                                    checked: item.tag ? true : null,
                                    type: "check_fill",
                                    fillText: item.fillText,
                                }
                                vm.qs_arr.push(obj);
                            }else if(item.tag == undefined && vm.qs_arr[vm.qs_arr.length-1].id !== "0"){
                                // console.log("管理台进行了配置且呼叫台进行了配置",item);
                                let obj = {
                                    id: '0',
                                    label: item.tag,
                                    isCommon: item.tag ? false : true,
                                    checked: item.tag ? true : null,
                                    type: "check_fill",
                                    fillText: item.fillText,
                                }
                                vm.qs_arr.push(obj);
                            }else if(!item.type && item.fillText ==''&& vm.qs_arr[vm.qs_arr.length-1].id !== "0"){
                                // console.log("管理台进行了配置且呼叫台进行了配置,呼叫台配置为空",item);
                                let obj = {
                                    id: '0',
                                    label: item.tag,
                                    isCommon: item.tag ? false : true,
                                    checked: item.tag ? true : null,
                                    type: "check_fill",
                                    fillText: item.fillText,
                                }
                                vm.qs_arr.push(obj);
                            }
                        })
                    }else {
                        // 未进行任何备注配置
                        if(vm.qs_arr.length == 0){
                            let empty = {
                                id: '',
                                isCommon: true,
                                fillText: '',
                                remark_id: '0'
                            }
                            vm.qs_arr.push(empty)
                        }
                        if(vm.qs_arr.length > 0&&vm.qs_arr[vm.qs_arr.length-1].remark_id !== '0'){
                            let empty = {
                                id: '',
                                isCommon: true,
                                fillText: '',
                                remark_id: '0'
                            }
                            vm.qs_arr.push(empty)
                        }
                    }
                    console.log("remark",vm.qs_arr);
                })
            },

            async getTableListAsync() {
                let vm = this;
                var info = new RestCallCenterPersonTagsControllerGetTags();
                info.p_id = vm.taskId;
                vm.qs_arr = []
                vm.tagInd = {}
                await info.send()
                return info.result
            },
            async getPatientTageAsync() {
                let vm = this;
                var info = new RestCallCenterPersonTagsControllerGetPatientTags();
                info.p_followUpPatientId = vm.patientData.followupPatientId;
                info.p_followUpTaskId = vm.taskId;
                await info.send()
                return info.result
            },
            async submitResult() {
                    let vm = this;
                    var arr = []
                    vm.qs_arr.forEach((item) => {
                        if (item.checked || item.isCommon) {
                            arr.push({tag: item.label, fillText: item.fillText, type: item.type})
                        }
                    })
                    if(arr.length==0){
                        return
                    }
                    var info = new RestCallCenterPersonTagsControllerEditPatientTags();
                    info.p_followUpPatientId = vm.patientData.followupPatientId;
                    info.p_followUpTaskId = vm.taskId;
                    info.p_nowUserId = sessionStorage.getItem('userid')
                    info.p_tags = JSON.stringify(arr)
                    await info.send()
                    if (info.result.status != 0) {
                        vm.$message.error("备注保存失败，请联系技术1" + info.result.retValue)
                    }
            }
        },
        created() {
        }
    }
</script>

<style scoped lang="scss">
.user_remark {
  height: 150px;
  overflow: auto;
  .remark_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    .common-item {
      margin-top: 10px;
      width: 100%;
      padding: 0 15px;
    }
    .remark_item-b {
      padding: 10px 15px;
      width: 100%;
      border-bottom: 1px solid #d8d8d8;

      .remark_item-b-l {
        text-align: left;
        display: flex;
        align-items: center;
        .remark_label {
          font-size: 14px;
        }
      }
    }
    &:last-child {
      .remark_item-b {
        border-bottom: none;
      }
    }
    .check_box {
      display: inline-block;
      width: 20px;
      height: 20px;
      background-image: url("./img/矩形@2x(6).png");
      background-size: 100% 100%;
    }

    .checked {
      display: inline-block;
      width: 20px;
      height: 20px;
      background-image: url("./img/矩形@2x(5).png");
      background-size: 100% 100%;
    }

    .item_text {
      .remark_fill {
        margin-top: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
</style>